/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */

//Provides the enum context for user to choose application
export enum ApplicationContext {
  ion = 'suite',
  admin = 'ctcadmin',
  assistcargo = 'assistcargo'
};
